import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import Divider from '@material-ui/core/Divider'
import ListItemText from '@material-ui/core/ListItemText'
import ListItemAvatar from '@material-ui/core/ListItemAvatar'
import Avatar from '@material-ui/core/Avatar'
import Typography from '@material-ui/core/Typography'
import Alert from '@material-ui/lab/Alert'
import CardTitle from '../shared/CardTitle'
import { dateUTCToLocalString } from '../../utils/dates'

const useStyles = makeStyles(theme => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap'
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120
    },
    docTypeSelect: {},
    root: {
        width: '100%',
        backgroundColor: theme.palette.background.paper
    },
    inline: {
        display: 'inline'
    }
}))

export default function TransactionCommentsCard(props) {
    const classes = useStyles()
    const [transactionComments, setTransactionComments] = React.useState(
        props.transactionComments
    )

    return (
        <>
            <CardTitle title="Comments" checkOn={false} disablePadding={true}>
                {transactionComments?.length === 0 && (
                    <Alert severity="info" className="w-100">
                        No records found.
                    </Alert>
                )}
                <List className={classes.root}>
                    {transactionComments?.map((comm, index) => {
                        const avatarText =
                            comm.userFirstName.charAt(0) +
                            comm.userLastName.charAt(0)
                        return (
                            <>
                                <ListItem alignItems="flex-start">
                                    <ListItemAvatar>
                                        <Avatar>{avatarText}</Avatar>
                                    </ListItemAvatar>
                                    <ListItemText
                                        disableTypography
                                        primary={
                                            // need a multiline text if the comment contains new lines
                                            <textarea
                                                className="form-control"
                                                rows={
                                                    comm.comment.split('\n')
                                                        .length -1
                                                }
                                                value={comm.comment}
                                                readOnly
                                                style={{
                                                    border: 'none',
                                                    fontSize: '14px',
                                                    color: 'black',
                                                    backgroundColor: 'transparent',
                                                    padding: '0px'
                                                }}
                                            ></textarea>
                                        }
                                        secondary={
                                            <React.Fragment>
                                                <span
                                                    style={{
                                                        fontSize: '12px',
                                                        fontWeight: 'bold'
                                                    }}
                                                >
                                                    {comm.userFirstName +
                                                            ' ' +
                                                            comm.userLastName}
                                                </span>
                                                <span
                                                    style={{
                                                        fontSize: '12px',
                                                        color: 'gray'
                                                    }}
                                                >
                                                    {comm.date
                                                        ? ' (' +
                                                        dateUTCToLocalString(comm.date) +
                                                        ')'
                                                        : ''}
                                                </span>
                                            </React.Fragment>
                                        }
                                    />
                                </ListItem>
                                <Divider variant="inset" component="li" />
                            </>
                        )
                    })}
                </List>
            </CardTitle>
        </>
    )
}
